export default "__VITE_ASSET__DnH6gYR4__"